import { getMessage } from '../../../../lib/translator'

export const COLUMN_KEYS = [
  'referenceNumber',
  'childOrderId',
  'source',
  'placedOn',
  'orderSlot',
  'status',
  'fillRate',
]

export const getTableHeaders = () => [
  getMessage('picking.orderDetail.table.header.referenceNumber'),
  getMessage('picking.orderDetail.table.header.childOrderId'),
  getMessage('picking.orderDetail.table.header.source'),
  getMessage('picking.orderDetail.table.header.placedOn'),
  getMessage('picking.orderDetail.table.header.orderSlot'),
  getMessage('picking.orderDetail.table.header.status'),
  getMessage('picking.orderDetail.table.header.fillRate'),
  // Trailing column for the row-open chevron; keeps header/row cell counts aligned.
  '',
]
